import { CompanyListWebPageRequest } from 'commons/types/DTO/bank/companyList/CompanyListWebPageRequest'
import { CompanyListWebPageResponse } from 'commons/types/DTO/bank/companyList/CompanyListWebPageResponse'
import { Request } from 'commons/utils/request/request'

export const getCompanyListWebPage = (opts?: CompanyListWebPageRequest): Promise<CompanyListWebPageResponse> =>
  Request.post(Request.urls.bank.companyListWebpages, opts)

export const deleteCompany = (id: number) => Request.delete(Request.urls.bank.company, { id })
